import styles from './TableTr.module.scss';

import type { FC, ReactNode } from 'react';

type Props = {
  id: string;
  title: string;
  required: boolean;
  children?: ReactNode;
  multiple?: boolean;
  errorMessage?: string;
};

export const TableTrFormLabel: FC<Props> = ({
  id,
  title,
  required: require,
  children,
  multiple,
  errorMessage,
}) => (
  <div className={`${styles.wrap}`}>
    <div className={styles['wrap-left']}>
      <label htmlFor={id}>{title}</label>
      {require && (
        <>
          <span className={`${styles.require}`}>必須</span>
          {multiple && <span className={`${styles.require}`}>複数選択可</span>}
        </>
      )}
    </div>
    <div className={styles['wrap-right']}>
      {children}
      {errorMessage && (
        <span className={styles['error-text']}>{errorMessage}</span>
      )}
    </div>
  </div>
);
